import React from "react";
import EmailCollectionRefusalContainer from "../containers/EmailCollectionRefusalContainer";

export default function EmailCollectionRefusal() {
  return <EmailCollectionRefusalContainer />;
}
